<template>
  <b-modal
    id="show-modal-processing"
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    hide-footer
    centered
    v-model="showModal"
  >
    <div
      class="d-flex flex-column align-items-center justify-center-center my-2 text-center"
    >
      <feather-icon id="modal-confirm" :icon="'AlertTriangleIcon'" size="80" :class="'icon-pendencia'" />
      <h2 class="text-center">{{ 'Estamos processando' }}</h2>
      <p class="modal-text">{{ 'Você será notificado quando a geração da ordem de serviço for concluída.' }}</p>
      <div class="d-flex mt-1">
        <b-button variant="primary-button" @click="confirmAction">
          Entendido
        </b-button>
      </div>
    </div>
  </b-modal>
</template>
    
<script>
import { BModal, BButton, BLink } from "bootstrap-vue";

export default {
  components: {
    BModal,
    BButton,
    BLink,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    confirmAction(modalEvent) {
      this.$emit("confirmed");
      modalEvent.preventDefault();
    },
  }
};
</script>


<style scoped>
.icon-pendencia {
  color: #ff9110;
  margin-bottom: 18px;
}
.modal-text {
  font-size: 14px;
  line-height: 21px;
  max-width: 383px;
}
</style>